import React from "react";
import type { PriceType, CommonFinanceInfoType } from "../../../../../../../common-deprecated/types/CommonTypes";
import { formatMonthlyFinancePrice } from "../../../../../../shared-logic/utils/priceUtils";
import { useBnbSelector } from "../../../../redux/store";

import * as Styles from "../../../../../../../common-deprecated/styles/v2/toyota/custom/price/MonthlyPrice";
import MonthlyRateDisclaimer from "../../common/price/MonthlyRateDisclaimer";
import PricePromoIcon from "../../common/price/PricePromoIcon";

type MonthlyPricePropsType = {
    price: PriceType;
    priceFormat: string;
    financeInfo: CommonFinanceInfoType;
};

const MonthlyPrice = ({ price, priceFormat, financeInfo }: MonthlyPricePropsType): JSX.Element | null => {
    const commonSettings = useBnbSelector((state) => state.commonSettings);

    const monthlyRateItems = formatMonthlyFinancePrice(price, financeInfo, commonSettings, priceFormat, price.monthly);
    const promotions = price.promotions.concat(price.onlineMonthlyPromotions);

    if (!price.monthly) return null;

    return (
        <Styles.PricesWrapper>
            {monthlyRateItems.labels.map((item, index) => (
                <div key={item.key}>
                    <Styles.Text dangerouslySetInnerHTML={{ __html: item.value }} />
                    {promotions.length > 0 && index < 1 && <PricePromoIcon promotions={promotions} />}
                </div>
            ))}
            <MonthlyRateDisclaimer price={price} priceFormat={priceFormat} financeInfo={financeInfo} />
        </Styles.PricesWrapper>
    );
};

export default MonthlyPrice;
